import helpers from "./helpers";

export default {
    getPublicAccessToken() {
        return "<Enter Access Token Here>";
    },
    getStorefrontToken() {

        return "5f882ab53fcd0cb1d201fad6895fe102";
    },
};
